





















import { Component, Vue, Prop } from 'vue-property-decorator';
import Button from '@/components/common/elements/Button.vue';
import SingleText from '@/components/common/elements/SingleText.vue';
import CheckBoxTable from '@/components/common/modules/CheckBoxTable.vue';
import Icon from '@/components/common/elements/Icon.vue';

@Component({
  components: { Button, SingleText, CheckBoxTable, Icon }
})
export default class CreateTaxSummary extends Vue {
  // データテーブルに表示するColumnリスト
  @Prop({ default: () => [] })
  private columns?: [];
  // データテーブルに表示するデータリスト
  @Prop({ default: () => [] })
  private data?: [];
}
